import { render } from "./SignUp.vue?vue&type=template&id=16e92602"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"
script.render = render

export default script